export const blockingReason = ({ summary, delivery, address }) => {
  if (!summary || summary.isEmpty) return "Your cart is empty.";
  if (summary.hasOutOfStock) return "Remove the out-of-stock items to continue.";
  if (!address?.hasCoordinates) return "Add a delivery address with a map location to continue.";

  const currencies = new Set(summary.carts.map((cart) => cart.currency));
  if (currencies.size > 1) {
    return "Your cart mixes currencies, which cannot be paid in one order. Remove one supplier to continue.";
  }

  const offline = summary.carts.find((cart) => !cart.supplierOnline);
  if (offline) {
    return `${offline.supplierName || "A supplier"} is currently offline. Remove them to continue.`;
  }

  if (delivery.hasError) return "We could not load delivery options. Please try again.";
  if (delivery.isLoading) return "Loading delivery options…";

  if (!delivery.hasAnyOptions) {
    return "No delivery option is available for your cart right now.";
  }

  if (!delivery.sharedOptions.length) {
    return summary.carts.length > 1
      ? "These suppliers have no delivery option in common. Remove one supplier to continue."
      : "No delivery option is available for your cart right now.";
  }

  if (!delivery.selectedOption) return "Choose a delivery type to continue.";

  const blockedLines = summary.carts.flatMap((cart) =>
    delivery.blockedLinesForOption(delivery.selectedOption, cart.lines)
  );

  if (blockedLines.length) {
    const label =
      blockedLines.length === 1 ? blockedLines[0].name : `${blockedLines.length} items`;

    return `${delivery.selectedOption.title} is not available for ${label} in your cart. Pick another delivery type.`;
  }

  return null;
};

export default blockingReason;
